import {LanguageUtils} from "../../core/utils/LanguageUtils"

export  function getProvinceSelectionModalData() {

    const en_data = {
      provincePlaceholder: "Select",
      provinces:[
            { label: "Alberta", value: "AB" },
            { label: "British Columbia", value: "BC" },
            { label: "Manitoba", value: "MB" },
            { label: "Newfoundland and Labrador", value: "NL" },
            { label: "New Brunswick", value: "NB" },
            { label: "Northwest Territories", value: "NT" },
            { label: "Nova Scotia", value: "NS" },
            { label: "Nunavut", value: "NU" },
            { label: "Ontario", value: "ON" },
            { label: "Prince Edward Island", value: "PE" },
            { label: "Quebec", value: "QC" },
            { label: "Saskatchewan", value: "SK" },
            { label: "Yukon", value: "YT" },
            { label: "International", value: "RoW" },
          ]};
          
     const fr_data={
      provincePlaceholder: "Sélectionnez",
      provinces: [
        { label: "Alberta", value: "AB" },
        { label: "Colombie-Britannique", value: "BC" },
        { label: "Manitoba", value: "MB" },
        { label: "Terre-Neuve-et-Labrador", value: "NL" },
        { label: "Nouveau-Brunswick", value: "NB" },
        { label: "Territoires du Nord-Ouest", value: "NT" },
        { label: "Nouvelle-Écosse", value: "NS" },
        { label: "Nunavut", value: "NU" },
        { label: "Ontario", value: "ON" },
        { label: "Île-du-Prince-Édouard", value: "PE" },
        { label: "Québec", value: "QC" },
        { label: "Saskatchewan", value: "SK" },
        { label: "Yukon", value: "YT" },
        { label: "International", value: "RoW" },
      ],
     }
     const currentLang=LanguageUtils.current();
     console.log(currentLang);
     if(currentLang==="en-us"){
      return en_data;
     }
     else{
      return fr_data; 
     }
    }
